import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle>Application info</AppTitle>
}

const skin = era.skin('routes/settings/info')

SettingsInfoPage.displayName = 'SettingsInfoPage'
export function SettingsInfoPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <ui.RenderSkin name='info' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
